export default class AuthService {
  static loggedIn(): boolean {
    return !!localStorage.getItem('login_token');
  }

  static setToken(token: string): void {
    localStorage.setItem('login_token', token);
  }

  static setRefreshToken(token: string): void {
    localStorage.setItem('refresh_token', token);
  }

  static getToken(): string {
    return `Bearer ${localStorage.getItem('login_token')}`;
  }

  static getRawToken(): string {
    return '' + localStorage.getItem('login_token');
  }

  static logout(): void {
    localStorage.removeItem('login_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('businessInfo');
    localStorage.clear();
  }
}
